<template>
  
  <div class="card widget-calendar">
    <div class="p-3 pb-0 card-header">
      <div class="mb-0" style="display: flex; flex-wrap: wrap;"> 
        <button
            type="button"
            id="add-btn"
            class="btn btn-primary"
            @click="this.$router.push({ name: 'LessonAdd', params: {}, query: filters })"
          >
            + Nuovo
          </button>

          <Vueform
            ref="form$"
            v-model="filters"
            sync
            style="display: block"
            @submit.prevent="" >
            <div style="display: flex; flex-wrap: wrap;">
              <SelectElement
                name="instructor_id"
                :native="false"
                placeholder="Istruttore"
                :items="instructors"
                style="margin: 2px 5px; width: 150px"
              />

              <SelectElement
                  name="field_id"
                  :native="false"
                  placeholder="Campo"
                  style="margin: 2px 5px; width: 150px"
                  :items="fields"
                ></SelectElement>

              <SelectElement
                    name="horse_id"
                    :delay="500"
                    :native="false"
                    placeholder="Cavallo"
                    :items="searchHorses"
                    style="margin: 2px 5px; width: 150px"
                    :search="true"
                  ></SelectElement>
            </div>

        </Vueform>
        
      </div>
      <div class="d-flex">
        <div class="mb-0 text-sm p font-weight-bold widget-calendar-day">
          {{ currentDay }}
        </div>
        <span>,&nbsp;</span>
        <div class="mb-1 text-sm p font-weight-bold widget-calendar-year">
          {{ currentYear }}
        </div>
      </div>
    </div>
    <div class="p-3 card-body">
      <div :id="id" data-toggle="widget-calendar"></div>
    </div>
  </div>
</template>

<script>
import "@fullcalendar/core/vdom";
import { Calendar } from "@fullcalendar/core";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import { lessonsService } from "../services/LessonsService";
import { horsesService } from "../services/HorsesService";

let calendar;

export default {
  name: "Calendar",
  props: {
    id: {
      type: String,
      default: "widget-calendar",
    },
    title: {
      type: String,
      default: "Calendar",
    },
    initialView: {
      type: String,
      default: "timeGridWeek",
    },

    initialDate: {
      type: String,
      default: () => {
        const today = new Date();
        return today.toISOString().split("T")[0];
      },
    },
    selectable: {
      type: Boolean,
      default: true,
    },
    editable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      events: [],
      currentDay: "",
      currentYear: "",
      fields: [],
      instructors: [],
      horses: [],
      loading: false,
      start: null,
      end: null,
      filters: {
        instructor_id: null,
        field_id: null,
        horse_id: null,
      }
    };
  },
  mounted() {
    const today = new Date();

    this.currentDay = today.toLocaleString("en-US", { weekday: "long" });
    this.currentYear = today.getFullYear();

    const modifiedToday = today.toISOString().split("T")[0];

    lessonsService.getInstructors().then((instructors) => {
      this.instructors = instructors.map((i) => ({ value: i.id, label: i.username }));
    });

    lessonsService.getFields(null).then((fields) => {
        this.fields = fields.map((f) => ({ value: f.id, label: f.name }));
      });

    lessonsService.getCalendarLessons(modifiedToday).then((lessons) => {
      const events = lessons.map((lesson) => ({
        title: lesson.student.username,
        start: lesson.start_date,
        end: lesson.end_date,
      }));

      calendar = new Calendar(document.getElementById(this.id), {
        plugins: [dayGridPlugin, interactionPlugin, timeGridPlugin, listPlugin],
        initialView: this.initialView,
        selectable: this.selectable,
        editable: this.editable,
        initialDate: this.initialDate,
        events: events,
        headerToolbar: {
          left: "prev,next today",
          center: "title",
          right: "timeGridWeek",
        },
        views: {
          dayGridMonth: {
            titleFormat: { month: "long", year: "numeric" },
          },
          timeGridWeek: {
            titleFormat: { month: "long", year: "numeric", day: "numeric" },
          },
          timeGridDay: {
            titleFormat: { month: "long", year: "numeric", day: "numeric" },
          },
          listWeek: {
            titleFormat: { month: "long", year: "numeric" },
          },
        },
        droppable: true,
        dateClick: (info) => {
          const utcDate = new Date(info.date.toISOString());
          const start_date = utcDate.toISOString().split('T')[0]; // YYYY-MM-DD
          const start_time = utcDate.toISOString().split('T')[1].slice(0, 5); // HH:MM
          this.$router.push({ name: 'LessonAdd', params: {}, query: {start_date, start_time, ...this.filters} })

        },
        eventClick: (info) => {
          this.$router.push({
            path: `/lessons/${info.event.extendedProps.lessonId}/edit`,
          });
        },
        timeZone: "UTC",
        eventContent: (info) => {
          const nickname = info.event.extendedProps.horseName;
          const fieldName = info.event.extendedProps.fieldName;

          const horseIcon = `<i class="fas fa-horse"></i> ${nickname}`;
          const fieldIcon = `<i class="fas fa-map"></i> ${fieldName}`;

          const customContent = document.createElement("div");
          customContent.innerHTML = `
      <strong>${info.event.title}</strong><br>
      ${horseIcon}&nbsp;&nbsp;&nbsp;${fieldIcon}
    `;

          return { domNodes: [customContent] };
        },
        datesSet: (dateInfo) => {
          const date = dateInfo.view.currentStart;
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const day = String(date.getDate()).padStart(2, "0");
          this.start = `${year}-${month}-${day}`;

          const endDate = dateInfo.view.currentEnd;

          const endYear = endDate.getFullYear();

          const endMonth = String(endDate.getMonth() + 1).padStart(2, "0");
          const endDay = String(endDate.getDate()).padStart(2, "0");

          this.end = `${endYear}-${endMonth}-${endDay}`;
          this.fetchEvents();
          
        },
      });

      calendar.render();
    });
  },
  methods: {
    fetchEvents() {
      lessonsService
        .getCalendarLessons(this.start.split("T")[0], this.end.split("T")[0], this.filters)
        .then((lessons) => {
          const dayMap = {
            Monday: 1,
            Tuesday: 2,
            Wednesday: 3,
            Thursday: 4,
            Friday: 5,
            Saturday: 6,
            Sunday: 0,
          };
          const generateEvents = (lesson) => {
            const startTime = new Date(lesson.start_time)
              .toISOString()
              .split("T")[1];
            const endTime = new Date(lesson.end_time)
              .toISOString()
              .split("T")[1];
            const startDate = new Date(lesson.start_date);
            const endDate = new Date(lesson.end_date);
            const daysOfWeek = lesson.days_of_week
              .split(",")
              .map((day) => dayMap[day.trim()]);
            const events = [];
            for (
              let current = new Date(startDate);
              current <= endDate;
              current.setDate(current.getDate() + 1)
            ) {
              if (daysOfWeek.includes(current.getDay())) {
                const eventStart = new Date(
                  `${current.toISOString().split("T")[0]}T${startTime}`
                );
                const eventEnd = new Date(
                  `${current.toISOString().split("T")[0]}T${endTime}`
                );

                events.push({
                  title: `${lesson.student.first_name} ${lesson.student.last_name}`,
                  horseName: lesson.horse.name,
                  fieldName: lesson.field.name,
                  start: eventStart,
                  end: eventEnd,
                  lessonId: lesson.id,
                });
              }
            }

            return events;
          };
          const events = lessons.flatMap(generateEvents);
          calendar.setOption("events", events);
        });
    },
    async searchHorses(query) {
      this.loading = true;
      const horses = await horsesService.searchHorses(query);
      this.loading = false;
      this.horses = horses.map((u) => ({
        value: u.id,
        label: u.name + " - " + (u.nickname ?? "NO NICKNAME"),
      }));
      return this.horses;
    },
  },

  beforeUnmount() {
    if (calendar) {
      calendar.destroy();
    }
  },
  watch: {
    filters(){
      this.fetchEvents();
    }
  }
};
</script>

<style scoped></style>
